/* src/app/components/auth-usage-charts/spending-plan/spending-plan-overview/spending-plan-overview.component.css */
.overview {
  --summary-columns: minmax(150px, 1fr) 150px 130px 64px 180px;
  --meter-width: 100px;
  --summary-gap: 16px;
  --summary-inset: 16px;
  display: block;
  border: 1px solid #ececec;
  border-radius: 8px;
  background: #ffffff;
  overflow: hidden;
}
.summary-header,
.hero {
  display: grid;
  grid-template-columns: var(--summary-columns);
  align-items: center;
  gap: 8px var(--summary-gap);
}
.summary-header {
  padding: 10px var(--summary-inset) 0;
}
.col-head {
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #8c8c8c;
  text-align: right;
  white-space: nowrap;
}
.col-head--budgeted {
  grid-column: 2;
}
.col-head--spent {
  grid-column: 3;
}
.col-head--used {
  grid-column: 4;
}
.hero {
  padding: 4px var(--summary-inset) 16px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
}
.hero:hover,
.hero:focus-visible {
  background: #f7f9f9;
  outline: none;
}
.hero-figure {
  min-width: 0;
}
.hero-label {
  margin: 0 0 2px;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #6b6b6b;
}
.hero-value {
  margin: 0;
  font-size: clamp(30px, 2.6vw, 48px);
  line-height: 1.1;
  font-weight: 600;
  color: #111111;
  white-space: nowrap;
}
.hero-cue {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  font-size: 12px;
  font-weight: 500;
  color: #0f8f8a;
}
.hero-cue::after {
  content: "\203a";
  font-size: 15px;
  line-height: 1;
}
.hero:hover .hero-cue,
.hero:focus-visible .hero-cue {
  text-decoration: underline;
}
.hero-meter {
  grid-column: 5;
  padding-left: 8px;
}
.meter-caption {
  margin: 8px 0 0;
  font-size: 12px;
  color: #6b6b6b;
  white-space: nowrap;
}
.amount {
  font-size: 15px;
  font-weight: 600;
  color: #111111;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  text-align: right;
}
.amount--budgeted {
  grid-column: 2;
}
.amount--spent {
  grid-column: 3;
}
.amount--used {
  grid-column: 4;
}
.amount-label {
  display: none;
}
.meter {
  display: block;
  position: relative;
  width: var(--meter-width);
  height: 10px;
  border-radius: 5px;
  overflow: hidden;
}
.meter-fill {
  display: block;
  height: 100%;
  border-radius: 0 5px 5px 0;
  min-width: 2px;
  transition: width 240ms ease-out;
}
.is-ok .meter {
  background: #d6f2f0;
}
.is-ok .meter-fill {
  background: #0f8f8a;
}
.is-warn .meter {
  background: #f7e6c4;
}
.is-warn .meter-fill {
  background: #b26a00;
}
.is-danger .meter {
  background: #f7d9d6;
}
.is-danger .meter-fill {
  background: #b3261e;
}
.is-empty .meter {
  background: #ededed;
}
.is-empty .meter-fill {
  background: #b4b4b4;
}
.category-head {
  margin: 0;
  padding: 12px var(--summary-inset) 0;
}
.category-head--solo {
  padding-bottom: 12px;
}
.category-title {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #6b6b6b;
}
.category-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 8px calc(var(--summary-inset) - 12px) 14px;
}
.category-item {
  flex: 0 1 320px;
  min-width: 220px;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
}
.category-item + .category-item {
  border-left: 1px solid #f0f0f0;
}
.category-item:hover,
.category-item:focus-visible {
  background: #f7f9f9;
  outline: none;
}
.item-name {
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #8c8c8c;
}
.item-amounts {
  margin: 3px 0 0;
  font-size: 15px;
  font-weight: 600;
  color: #111111;
  font-variant-numeric: tabular-nums;
}
.item-of {
  font-weight: 400;
  color: #8c8c8c;
  padding: 0 2px;
}
.item-used {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 3px 0 0;
  font-size: 12px;
  color: #6b6b6b;
}
.severity-dot {
  display: inline-block;
  flex: 0 0 auto;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.is-ok .severity-dot {
  background: #0f8f8a;
}
.is-warn .severity-dot {
  background: #b26a00;
}
.is-danger .severity-dot {
  background: #b3261e;
}
.is-empty .severity-dot {
  background: #b4b4b4;
}
@media (max-width: 900px) {
  .summary-header {
    display: none;
  }
  .hero {
    grid-template-columns: repeat(3, 1fr);
  }
  .hero-figure {
    grid-column: 1 / -1;
  }
  .hero-meter {
    grid-column: 1 / -1;
    padding-left: 0;
  }
  .meter {
    width: 100%;
  }
  .amount--budgeted,
  .amount--spent,
  .amount--used {
    grid-column: auto;
    text-align: left;
  }
  .amount-label {
    display: block;
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: #8c8c8c;
  }
  .category-item + .category-item {
    border-left: 0;
    border-top: 1px solid #f0f0f0;
  }
}
/*# sourceMappingURL=spending-plan-overview.component-53P3MBT2.css.map */
